export const iconFontAwesomeChartsDiagramsDiagramNext = (
	<i className="fa-solid fa-diagram-next"></i>
);
